import { render } from "./DraftBookingFlow_treatment_category_first.vue?vue&type=template&id=e97ab06c&scoped=true"
import script from "./DraftBookingFlow_treatment_category_first.vue?vue&type=script&lang=js"
export * from "./DraftBookingFlow_treatment_category_first.vue?vue&type=script&lang=js"

import "./DraftBookingFlow_treatment_category_first.vue?vue&type=style&index=0&id=e97ab06c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97ab06c"]])

export default __exports__